<template>
  <div class="OnboardingInteractiveFormContainer">
    <div v-if="busy" class="loading">
      <Spinner />
    </div>
    <OAuthCreateAccountInteractiveFormContainer
      v-if="displayContainer('createAccount')"
      product="personal_loan"
      @submit="onUserSubmitted"
    />
    <PersonaInfoInteractiveFormContainer
      v-if="displayContainer('personaInfo')"
      @personaInfoSubmitted="onPersonaInfoSubmitted"
    />
    <PersonaResidenceInteractiveFormContainer
      v-if="displayContainer('personaResidence')"
      @personaResidenceSubmitted="onPersonaResidenceSubmitted"
    />
    <PersonaFinanceInteractiveFormContainer
      v-if="displayContainer('personaFinance')"
      @personaFinanceSubmitted="onPersonaFinanceSubmitted"
    />
    <UserAttributesInteractiveFormContainer
      v-if="displayContainer('userAttributes')"
      @userAttributesSubmitted="onUserAttributesSubmitted"
    />
    <AutoColdOfferInteractiveFormContainer
      v-if="displayContainer('autoColdOffer')"
      simulation-source="onboarding_nc"
      @submit="onAutoColdOfferSubmitted"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { GtmPushDataLayer } from '@/helpers/google'
import OAuthCreateAccountInteractiveFormContainer from '@/containers/forms/oauth/interactive/OAuthCreateAccountInteractiveFormContainer.vue'
import AutoColdOfferInteractiveFormContainer from '@/containers/forms/loans/auto/cold-offer/interactive/AutoColdOfferInteractiveFormContainer.vue'
import Spinner from '@/aasgard/components/feedback/Spinner.vue'
import UserAttributesInteractiveFormContainer from '@/containers/forms/user/interactive/UserAttributesInteractiveFormContainer.vue'
import PersonaInfoInteractiveFormContainer from '@/containers/forms/persona/interactive/PersonaInfoInteractiveFormContainer.vue'
import PersonaResidenceInteractiveFormContainer from '@/containers/forms/persona/interactive/PersonaResidenceInteractiveFormContainer.vue'
import PersonaFinanceInteractiveFormContainer from '@/containers/forms/persona/interactive/PersonaFinanceInteractiveFormContainer.vue'
import { abTest } from '~/helpers/abTest'
export default {
  name: 'NoCollateralInteractiveFormContainer',
  components: {
    OAuthCreateAccountInteractiveFormContainer,
    AutoColdOfferInteractiveFormContainer,
    Spinner,
    UserAttributesInteractiveFormContainer,
    PersonaInfoInteractiveFormContainer,
    PersonaResidenceInteractiveFormContainer,
    PersonaFinanceInteractiveFormContainer,
  },
  data() {
    return {
      currentContainerDisplayed: 'createAccount',
      loan: undefined,
      busy: false,
    }
  },
  computed: {
    ...mapGetters({
      gtUser: 'user/user/gtUser',
      gtUserAttributes: 'user/user-attributes/gtUserAttributes',
      personaData: 'user/persona/personaData',
      gtCreditScoreLatest:
        'products/credit-score/credit-score/gtCreditScoreLatest',
    }),
  },
  mounted() {
    this.loan = JSON.parse(localStorage.getItem('jb.state.loan') || '{}')
    this.gEventBus.emit('layout-unlogged:update-current-progress', 10)
  },
  methods: {
    abTest,
    ...mapActions({
      simulateNoCollateralLoan:
        'products/loans/no-collateral/no-collateral/simulateNoCollateralLoan',
      actSetLastLoanInteraction: 'ui/user-activity/actSetLastLoanInteraction',
      actCreditScoreGetLatest:
        'products/credit-score/credit-score/actCreditScoreGetLatest',
      actEmitGaEvent: 'services/ga/actEmitGaEvent',
    }),
    onUserSubmitted() {
      this.currentContainerDisplayed = 'personaInfo'
      this.gEventBus.emit('layout-unlogged:update-current-progress', 16)
    },
    onPersonaInfoSubmitted() {
      this.currentContainerDisplayed = 'personaResidence'
      this.gEventBus.emit('layout-unlogged:update-current-progress', 32)
    },
    onPersonaResidenceSubmitted() {
      this.currentContainerDisplayed = 'personaFinance'
      this.gEventBus.emit('layout-unlogged:update-current-progress', 48)
    },
    async onPersonaFinanceSubmitted() {
      this.busy = true
      try {
        await this.actCreditScoreGetLatest()
        await this.simulateNoCollateral()
      } catch (e) {}

      this.busy = false
      this.currentContainerDisplayed = 'userAttributes'
      this.gEventBus.emit('layout-unlogged:update-current-progress', 72)
    },
    onUserAttributesSubmitted() {
      this.gEventBus.emit('layout-unlogged:update-current-progress', 88)

      if (this.gtUserAttributes.has_auto) {
        this.currentContainerDisplayed = 'autoColdOffer'
      } else {
        this.redirectToSimulatingPage()
      }
    },
    onAutoColdOfferSubmitted() {
      this.gEventBus.emit('layout-unlogged:update-current-progress', 100)
      this.busy = true
      this.redirectToSimulatingPage()
    },
    async simulateNoCollateral() {
      // GTM EVENT
      GtmPushDataLayer({
        user_id: this.gtUser?.id ?? '',
        nocollateral_simulation_amount: this.loan?.amount ?? '',
      })

      this.actSetLastLoanInteraction('no-collateral')
      return await this.simulateNoCollateralLoan({
        loan: {
          amount: Number(this.loan?.amount || 3000),
          duration: Number(this.loan?.duration || 12),
          reason: this.loan?.reason,
          ad_campaign: sessionStorage.getItem('utm_campaign') || '',
          ad_source: sessionStorage.getItem('utm_source') || '',
          ad_group: '',
        },
        persona: this.personaData,
        source: 'loan_onboarding_interactive_form',
        user: this.gtUser,
        score: this.gtCreditScoreLatest?.data?.score ?? 0,
      })
    },
    redirectToSimulatingPage(extraQuery) {
      this.$router.push({
        path: '/simulando',
        query: {
          ...this.$route?.query,
          ...extraQuery,
          product: 'no-collateral',
        },
      })
    },
    displayContainer(container) {
      return this.currentContainerDisplayed === container
    },
  },
}
</script>
<style lang="scss">
.OnboardingInteractiveFormContainer {
  position: relative;
  max-width: 600px;
  margin: 0 auto;
  height: 100%;

  .loading {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    z-index: 999;
    background: $color-white-high;

    .Spinner {
      margin-top: 80px;
    }
  }
}
</style>
